import React, { useEffect, useState } from "react";
import "./WinnersAboutUsBlue.css";
import { useInView } from "react-intersection-observer";
import img from "../../Images/Rectangle 20 (2).png";

import icon1 from "../../Images/fakec.webp";
import icon2 from "../../Images/u1.webp";
import icon3 from "../../Images/u2.webp";
import icon4 from "../../Images/u3.webp";
import icon5 from "../../Images/u4.png";
import icon6 from "../../Images/u5.png";

import logo from "../../Images/logow.png";


import icon7 from "../../Images/v1.png";
import icon8 from "../../Images/v2.png";
import icon9 from "../../Images/v3.png";
import icon10 from "../../Images/v4.png";
import icon11 from "../../Images/v5.png";
import icon12 from "../../Images/v6.png";

import icon13 from "../../Images/r1.png";
import icon14 from "../../Images/r2.png";
import { BadgeCheck, BookCheck, Store, UserRoundKey } from "lucide-react";



const Counter = ({ end, label }) => {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  useEffect(() => {
    if (inView) {
      let start = 0;
      const duration = 2000; // total duration of animation in ms
      const increment = Math.ceil(end / (duration / 20));

      const counter = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(counter);
        } else {
          setCount(start);
        }
      }, 20);
    }
  }, [inView, end]);

  return (
    <div className="achievement_box_blue" ref={ref}>
      <p className="achieve_number_para_blue">{count.toLocaleString()}+</p>
      <p className="achive_name_blue">{label}</p>
    </div>
  );
};

const AchievementsBlue = () => {
  return (
    <>
      <section className="about-story-blue">
        <div className="about-story-container-blue">

          

          <div className="about-story-content-blue">

            <span className="story-tag-blue">
              Our Story
            </span>

            <h2>
              Real Estate Intelligence
              <span> Built For Professionals</span>
            </h2>

            <p>
              TheWinners2 is a trusted real estate data platform helping
              brokers, consultants, investors, and agencies access verified
              property information across Gurgaon, Noida, and Delhi NCR.
            </p>

            <p>
              We simplify property discovery by delivering accurate owner
              details, market trends, sales records, rental insights, and
              verified listings — all from a single platform.
            </p>

            <div className="story-features-blue">
              <div className="story-feature-item-blue">
                {/* <img src={icon7} alt="" /> */}
                <BadgeCheck />
                <span>Verified Property Data</span>
              </div>
              <div className="story-feature-item-blue">
                {/* <img src={icon5} alt="" /> */}
                <Store />
                <span>Real-Time Market Insights</span>
              </div>
              <div className="story-feature-item-blue">
                {/* <img src={icon1} alt="" /> */}
                <UserRoundKey />
                <span>Owner Contact Access</span>
              </div>
              <div className="story-feature-item-blue">
                {/* <img src={icon10} alt="" /> */}
                <BookCheck />
                <span>Trusted By Industry Experts</span>
              </div>
            </div>

            {/* <button className="story-btn-blue">
        Learn More
      </button> */}

          </div>

          <div className="about-story-image-blue">
            <img src={img} alt="About Winners" />

            {/* <div className="story-badge-blue">
              <h3>15+</h3>
              <span>Years Experience</span>
            </div> */}
          </div>

        </div>
      </section>
    </>
  );
};

export default AchievementsBlue;
